import axios from 'axios';

const baseURL = process.env.REACT_APP_SIGN_API_URL || 'http://localhost:8091';
const signApi = axios.create({ baseURL });

export default signApi;
